<template>
  <div class="upload">
    <img class="main-logo" src="../assets/logo.png" />
    <div v-cloak @drop.prevent="addFile" @dragover.prevent class="dnd-file-select">
      <input
        id="filePicker"
        class="inputfile"
        type="file"
        name="filePicker"
        multiple
        accept="*/*"
        @change="addFile"
      />
      <label class="label" for="filePicker">
        <div class="iconHolder">
          <slot name="icon">
            <svg slot="icon" height="40" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 32h12v-12h8l-14-14-14 14h8zm-8 4h28v4h-28z" fill="#CACFD2" />
            </svg>
          </slot>
          <br />
          <slot name="label">
            Zieh es hier rein
            oder
            klick!
          </slot>
        </div>
      </label>
    </div>

    <div class="controls-container">
      <button v-if="!uploading" class="btn" :disabled="uploadDisabled" @click="upload">Senden</button>
      <p v-else class="upload-progress">{{uploadPercentage}} %</p>
      <br />

      <a
        class="download-link"
        v-if="uploadDone"
        :href="downloadHost + fileHash"
      >{{downloadHost + fileHash}}</a>
      <br />
      <br />
      <button v-if="uploadDone" class="btn" @click="reload">Nochmal!</button>
    </div>

    <table class="file-display">
      <tr v-for="file in files" :key="file.name">
        <td>{{file.name}}</td>
        <td>{{ Math.floor(file.size /1024) }} kb</td>
        <td class="delete-file-btn" @click="removeFile(file)">
          <i class="far fa-trash-alt"></i>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import JSZip from "jszip";
import Axios from "axios";
export default {
  name: "upload",

  data() {
    return {
      files: [],
      uploadURL: window.location.protocol + "//" + window.location.host + "/api/upload",
      downloadHost: window.location.protocol + "//" + window.location.host + "/download/",
      //uploadURL: window.location.protocol + "//" + "localhost:3011" + "/api/upload",
      //downloadHost: window.location.protocol + "//" + "localhost:3011" + "/download/",
      fileHash: "",
      uploadPercentage: 0,
      uploading: false,
      uploadDone: false
    };
  },
  computed: {
    uploadDisabled() {
      return this.files.length === 0;
    }
  },
  methods: {
    reload() {
      window.location.reload();
    },

    addFile(e) {
      let droppedFiles;
      if (e.type == "change") {
        droppedFiles = e.srcElement.files;
      } else {
        droppedFiles = e.dataTransfer.files;
      }
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        this.files.push(f);
      });
    },
    removeFile(file) {
      this.files = this.files.filter(f => {
        return f != file;
      });
    },
    upload() {
      var vm = this;
      this.uploading = true;
      var formData = new FormData();

      this.files.forEach(async (f, x) => {
        formData.append("file_" + x, f);
      });
      formData.append("expirationDate", 100);
      vm.files = [];
      Axios.post(vm.uploadURL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Mime-Type": "application/zip"
        },
        onUploadProgress: ProgressEvent => {
          vm.uploadPercentage = parseInt(
            Math.round((ProgressEvent.loaded * 100) / ProgressEvent.total)
          );
        }
      })
        .then(function(response) {
          console.log(response);

          vm.files = [];
          vm.fileHash = response.data.hash;
          vm.uploadDone = true;
        })
        .catch(function(error) {
          console.log(error);

          vm.files = [];
          vm.uploadDone = false;
        });
    }
  }
};
</script>

<style  scoped>
.upload {
  margin: 0;
  padding: 1%;
  width: 100%;
  height: 100%;
  background: #fff;
}

.main-logo {
  width: 85.25px;
  height: 64px;
  margin-left:10px;
  margin-top:10px;
}

.dnd-file-select {
  background: #fff;
  width: 60%;
  height: 250px;

  margin: 5% auto 5% auto;
  border-radius: 5px;
  text-align: center;
  -webkit-box-shadow: 0px 0px 121px 8px rgba(0, 0, 0, 0.56);
  -moz-box-shadow: 0px 0px 121px 8px rgba(0, 0, 0, 0.56);
  box-shadow: 0px 0px 121px 8px rgba(0, 0, 0, 0.56);
}

.bgArea {
  transition: 0.3s;
  background: #efeff0;
  display: grid;
  grid-template-rows: 60% 40%;
  padding: 25px 10px;
  width: 100%;
  outline: 2px dashed #cacfd2;
  outline-offset: -10px;
  color: #3b3e40;
  text-align: center;
}
.inputfile {
  opacity: 0;
  overflow: hidden;
  position: absolute;
}

.iconHolder {
  padding: 90px;
}

.label {
  cursor: pointer;
  text-align: center;
  font-size: 0.9rem;
}
.active {
  background-color: #d7dbdd;
  outline-color: #f2f3f4;
}
.file-display {
  width: 50%;
  min-width: 50%;
  max-width: 50%;
  margin: 0 auto;
  background: #efeff0;
  border-collapse: collapse;
}
.file-display tr:hover {
  background-color: #696969;
}
.file-display tr:nth-child(even) {
  background-color: #dadae9;
}
.file-display tr:nth-child(even):hover {
  background-color: #696969;
}
.file-display td {
  padding: 15px;
  text-align: left;
}
.controls-container {
  text-align: center;
}
.btn {
  background-color: #c00070;
  margin-bottom: 4%;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  transition: background-color 0.5s;
  border-radius: 50px;
}
.btn:hover {
  background-color: #990152;
}

.btn:disabled,
.btn[disabled] {
  background-color: #343342;
}

.delete-file-btn {
  color: #39393a;
  transition: color 0.5s;
}

.delete-file-btn:hover {
  color: #ffd131;
}

.upload-progress {
  font-size: 3em;
  color: #ffd131;
}

.download-link {
  text-decoration: underline;
  text-align: center;
  font-size: 2em;
}

@media only screen and (max-width: 440px) {
  .bgArea {
    padding: 18px 10px;
    grid-template-rows: 50% 50%;
    grid-row-gap: 5px;
  }
}
</style>